import * as paths from "../../../constants/paths";
import { getCompanySponsorRating, getCompanyStrength } from "../../../helpers/helpers";

export default function CompanyStats({company,totalJobs}) {
  return (
    <>
      <div className="company_stats">
        <div className="h4">Company Stats</div>
        <div className="inner">
          <div className="icon">
            <img
              src={paths.SITE_BASE_URL + "/images/icon_stat_file.png"}
              alt=""
            />
          </div>
          <div className="text">
            <span>CoS Issued</span>
            <div className="num">{company?.computed_cos_total?? 0}</div>
          </div>
        </div>
        <div className="inner">
          <div className="icon">
            <img
              src={paths.SITE_BASE_URL + "/images/icon_stat_shield.png"}
              alt=""
            />
          </div>
          <div className="text">
            <span>Sponsor Rating</span>
            <div className="num">{getCompanySponsorRating(company?.sponsor_rating)}</div>
          </div>
        </div>
        <div className="inner">
          <div className="icon">
            <img
              src={paths.SITE_BASE_URL + "/images/icon_stat_chart.png"}
              alt=""
            />
          </div>
          <div className="text">
            <span>Strength</span>
            <div className="num">{getCompanyStrength(company?.strength)}</div>
          </div>
        </div>
        <div className="inner">
          <div className="icon">
            <img
              src={paths.SITE_BASE_URL + "/images/icon_stat_briefcase.png"}
              alt=""
            />
          </div>
          <div className="text">
            <span>Open Jobs</span>
            <div className="num">{totalJobs}</div>
          </div>
        </div>
        <div className="main_badge badge_applicant">
          <img
            src={paths.SITE_BASE_URL + "/images/icon_mini_check.png"}
            alt=""
          />
          <div className="data">
            <div className="title">Overseas Applicants</div>
            <p>{company?.overseas_applicants == "yes" ? "Accepts applicants from overseas candidates." : "Does not accept applicants from overseas"}</p>
          </div>
        </div>
        <div className="main_badge badge_visa">
          <img
            src={paths.SITE_BASE_URL + "/images/icon_mini_visa.png"}
            alt=""
          />
          <div className="data">
            <div className="title">Visa Support</div>
            <p>{company?.visa_support}</p>
          </div>
        </div>
      </div>
    </>
  );
}
